import { render, staticRenderFns } from "./CHL.vue?vue&type=template&id=6bef4413&scoped=true&"
import script from "./CHL.vue?vue&type=script&lang=js&"
export * from "./CHL.vue?vue&type=script&lang=js&"
import style0 from "./CHL.vue?vue&type=style&index=0&id=6bef4413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bef4413",
  null
  
)

export default component.exports